import React, { useEffect } from "react";
import { Divider, Stack } from "@mui/material";
import SidebarCard from "./sidebar-card";
import SectionNews from "./section-news";
import { useSourceSearch } from "features/SourceSearch";
import { databaseCategories, getCategories, publishersArray } from "features/SourceSearch/data/search-fields.data";
import { biasCategories } from "data/search-labels";
import { find } from "lodash";
import { useSelector } from "react-redux";

export const CategorySection = ({
  source,
  category,
  sectionNews,
  isLoading,
  onFetchMore,
}) => {
  const {
    currentSearchTerm,
    buildSearchUrl,
    startDate,
    endDate,
    currentTimeframe,
    handleSourceCategoryChange
  } = useSourceSearch();
  const { isHomeschool } = useSelector((state) => state.account);
  const categories = getCategories(isHomeschool);
  const categoryName = category.categoryName_chr || category.label;

  const getCategory = () => {
    let category_key = null;

    const categoryList = source === "rating" ? biasCategories : source === "partner-publishers" ? publishersArray : source === "databases" ? databaseCategories : categories;

    category_key = categoryList.filter(
      (curr_category) =>
        curr_category?.label &&
        categoryName &&
        curr_category.label === categoryName
    );

    return category_key.length > 0
      ? category_key[0]
      : { label: "Unknown", value: null };
  };

  const sidebarUrl = () => {
    try {
      const categories = handleSourceCategoryChange(source);

      const catObj = find(categories, { label: categoryName });
      const url = buildSearchUrl({
        query: currentSearchTerm,
        source,
        category: catObj == null ? null : catObj.key,
        date: currentTimeframe,
        startDate,
        endDate,
      });
      return url;
    } catch (e) {
      return "";
    }
  }
  return (
    !category.isHidden_ysn && (
      <React.Fragment>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          gap={2}
          // alignItems={"stretch"}
          py={2}
        >
          <SidebarCard
            category={category}
            loading={isLoading}
            link={sidebarUrl()}
          />
          <SectionNews
            category={getCategory()?.label}
            query={currentSearchTerm}
            sectionNews={sectionNews}
            isLoading={isLoading}
            onFetchMore={onFetchMore}
          />
        </Stack>
        <Divider
          sx={{
            ml: { sm: "31vw", md: "22vw" },
            display: { xs: "none", sm: "block" },
          }}
        />
      </React.Fragment>
    )
  );
};
